<template>
  <div>
    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="items"
      :pagination.sync="sortOptions"
      hide-actions
    >
      <template v-slot:no-data>
        <div class="text-xs-center">{{ noDataText }}</div>
      </template>
      <template v-slot:items="props">
        <tr>
          <td class="px-2 no-wrap text-xs-right">
            {{ props.item.id }}
          </td>
          <td class="px-2">
            <MapReportName
              :id="props.item.id"
              :name="props.item.name"
              :status="props.item.status"
              :url="props.item.url"
              @onClickSave="onClickSave"
            />
          </td>
          <td class="px-2">
            <MapReportInsertionOrderName
              :insertionOrderId="props.item.insertionOrderId"
              :insertionOrderName="props.item.insertionOrderName"
            />
          </td>
          <td class="px-2">{{ props.item.extractionPeriod }}</td>
          <td class="px-2">
            <MapReportStatus :mapReportStatus="props.item.status" />
          </td>
          <td class="px-2">{{ props.item.createdTime }}</td>
          <td class="px-2">{{ props.item.updatedTime }}</td>
          <td class="px-2">
            <ButtonDelete
              @deleteExec="deleteExec"
              :id="props.item.id"
              :name="props.item.name"
            />
          </td>
        </tr>
        <MapReportRejectReason
          :status="props.item.status"
          :rejectReason="props.item.rejectReason"
        />
      </template>
    </v-data-table>
  </div>
</template>

<script>
import MapReportStatus from '@/components/Advertiser/Report/MapReport/MapReportRequestListStatus'
import MapReportName from '@/components/Advertiser/Report/MapReport/MapReportRequestListName'
import MapReportInsertionOrderName from '@/components/Advertiser/Report/MapReport/MapReportRequestListInsertionOrderName'
import MapReportRejectReason from '@/components/Advertiser/Report/MapReport/MapReportRequestListRejectReason'
import ButtonDelete from '@/components/Advertiser/Report/MapReport/MapReportRequestListButtonDelete'
import { mapActions, mapGetters } from 'vuex'
import { snackbarType } from '@/vuex/modules/ui/snackbar/constants'

export default {
  name: 'MapReportRequestList',
  components: {
    MapReportStatus,
    MapReportName,
    MapReportInsertionOrderName,
    MapReportRejectReason,
    ButtonDelete,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      headers: [
        { text: 'ID', value: 'id', class: 'px-2' },
        { text: 'レポート名', value: 'name', class: 'px-2' },
        { text: '案件名', value: 'insertionOrderName', class: 'px-2' },
        {
          text: '抽出期間',
          value: 'extractionDate',
          class: 'px-2',
          width: '120',
          sortable: false,
        },
        { text: 'ステータス', value: 'status', class: 'px-2' },
        { text: '申請日時', value: 'createdTime', class: 'px-2' },
        { text: '更新日時', value: 'updatedTime', class: 'px-2' },
        { text: '削除', class: 'px-2', sortable: false },
      ],
      sortOptions: {
        sortBy: 'id',
        descending: true,
        rowsPerPage: -1,
      },
    }
  },
  computed: {
    ...mapGetters('mapReport', [
      'keyword',
      'advertiserId',
      'pageNo',
      'loading',
    ]),
    noDataText() {
      return this.loading ? '' : 'データがありません。'
    },
  },
  methods: {
    ...mapActions('mapReport', {
      initSearchItems: 'INIT_SEARCH_ITEMS',
      setMapReport: 'SET_MAP_REPORT',
    }),
    ...mapActions('snackbar', {
      showSnackbar: 'SHOW_SNACKBAR',
    }),
    updateMapReport() {
      this.setMapReport({
        keyword: this.keyword,
        advertiserId: this.advertiserId,
        pageNo: this.pageNo,
      })
    },
    initSearch() {
      this.initSearchItems(this.$route.params.advertiserId)
      this.updateMapReport()
    },
    onClickSave(name) {
      this.showSnackbar({
        type: snackbarType.SUCCESS,
        message: `${name}に更新しました。`,
      })
      this.initSearch()
    },
    deleteExec() {
      this.showSnackbar({
        type: snackbarType.SUCCESS,
        message: '削除しました。',
      })
      this.initSearch()
    },
  },
}
</script>

<style scoped></style>
